// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12kU4","col":"styles_col__CQy2c"};